export default {
  client_id: '1_29qngqa8afms8o4ssw44s04gc044o44o04gco88s4g4k84480o',
  client_secret: '1cyhbe9ykd0gk48kkggosc4gk4ggkww4ss00cs004k0oo84gco'
}



// WEBPACK FOOTER //
// ./src/api/authConfig.js